<template>
  <div class="form-list">
    <el-form
      class="form"
      ref="form"
      label-position="right"
      label-width="160px"
    >
      <el-form-item label="所属学员">
        <v-avatar-nickname
          :value="post.student.selfie"
          :nickname="post.student.student_name"
          :is-center="false"
          :nickname-overflow="false"
          :link-page-name="studentDetailName"
          :link-page-id="post.student_id"
          :avatar-size="50"
        />
      </el-form-item>

      <el-form-item label="课次券 ID">
        {{ id }}
      </el-form-item>

      <el-form-item label="办理来源">
        <el-tag v-if="post.is_app" size="small" type="warning">小程序</el-tag>
        <el-tag v-else size="small" type="info">门店</el-tag>
      </el-form-item>
      <el-form-item label="办理时间">{{ post.add_time | timeToYmdHis }}</el-form-item>
      <template v-if="post.add_administrator_id">
        <el-form-item label="办理人">
          <v-avatar-nickname
            :value="post.add_administrator.avatar"
            :nickname="post.add_administrator.nickname"
            :is-center="false"
          />
        </el-form-item>
      </template>
      <el-form-item v-else label="办理人">学员本人于小程序办理</el-form-item>
      <el-form-item label="归属门店">
        <span :class="{ 'info-color': !post.store_id }">{{ post.store_name || '未归属' }}</span>
      </el-form-item>
      <el-form-item label="归属依据">
        <span v-if="post.store_id">{{ post.store_source_name }}</span>
        <span v-else class="info-color">尚未归属，签到/爽约后自动归属到课程门店</span>
      </el-form-item>

      <el-form-item label="课次券类型">{{ post.card_ticket_type_name }}</el-form-item>

      <el-form-item label="仅限新生办理">
        <span v-if="post.is_new" class="success-color">是</span>
        <span v-else class="danger-color">否</span>
      </el-form-item>

      <el-form-item
        label="有效天数"
        prop="expire_days"
      >
        {{ post.expire_days | toYuan }} 天
      </el-form-item>

      <el-form-item
        label="剩余有效次数"
        prop="expire_number"
      >
        {{ post.expire_number | toYuan }} 次
      </el-form-item>

      <el-form-item label="生效时间">
        <span v-if="post.effect_time">{{ post.effect_time | timeToYmdHis }}</span>
        <span v-else class="success-color">未生效</span>
      </el-form-item>

      <el-form-item label="过期时间">
        <span v-if="post.expire_time">{{ post.expire_time | timeToYmdHis }}</span>
        <span v-else class="success-color">未开券</span>
      </el-form-item>

      <template v-if="post.card_id">
        <el-form-item label="收款方式" class="success-color">办卡附赠</el-form-item>
        <el-form-item label="所属课卡">
          <router-link :to="RouteConfig.cardDetail.to(post.card_id)" class="primary-color">{{ post.card_name }}</router-link>
        </el-form-item>
        <el-form-item label="所属课卡ID">{{ post.card_id }}</el-form-item>
        <el-form-item label="开卡时不自动开券">
          <el-switch v-model="post.is_not_auto_start" :disabled="true" :active-value="1" :inactive-value="0"/>

          <el-alert
            v-if="post.is_not_auto_start"
            title="本课次券将在初次签到课程时开券，但已绑定的课卡次数用尽后才会生效，未生效时无法进行预约并开券。"
            type="warning"
            show-icon
            :closable="false"
          />
          <el-alert
            v-else
            title="本课次券将在已绑定的课卡开卡时自动开券，课次券有效期将与课卡保持一致，但课卡次数用尽后才会生效，即已开券但未生效仍无法使用。"
            type="info"
            show-icon
            :closable="false"
          />

        </el-form-item>
      </template>
      <template v-else>
        <el-form-item label="收款方式">
          <span v-if="post.actual_payment > 0">{{ findPaymentModeName(post.card_payment_mode_id) }}</span>
          <span v-else>
            <span v-if="post.card_id" class="success-color">办卡附赠</span>
            <span v-else class="success-color">免费赠送</span>
          </span>
        </el-form-item>
        <el-form-item v-if="post.card_payment_mode_id === paymentModes.youZan.value" label="有赞核销金额">
          {{ post.you_zan_payment | toYuan }} 元
        </el-form-item>
        <el-form-item label="实际付款">
          <span class="danger-color">{{ post.actual_payment | toYuan }}</span> 元
          <el-alert
            v-if="post.integral > 0"
            :title="`积分抵扣 ${post.integral} 元`"
            type="warning"
            show-icon
            :closable="false"
          />
        </el-form-item>
        <el-form-item label="收款凭证" prop="payment_remark">
          <v-img v-if="post.receipt" :value="post.receipt" class="cover"/>
          <span v-else class="info-color">未上传</span>
        </el-form-item>
        <el-form-item label="付款备注" prop="payment_remark">
          <span v-if="post.payment_remark" class="success-color">{{ post.payment_remark }}</span>
          <span v-else class="info-color">未填写</span>
        </el-form-item>
        <el-form-item label="付款备注图片" prop="payment_remark">
          <v-img v-if="post.remark_file" :value="post.remark_file" class="cover"/>
          <span v-else class="info-color">未上传</span>
        </el-form-item>
      </template>

      <el-form-item>
        <el-button @click="RouteConfig.cardTicketList.back">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { paymentModes } from "@/enums/paymentModes";
import { show } from '@/api/card-ticket';
import { findPaymentModeName } from "@/enums/paymentModes";

export default {
  name: RouteConfig.cardTicketDetail.name,
  data: () => ({
    RouteConfig,
    paymentModes,
    studentDetailName: RouteConfig.studentDetail.name,
    isLoadFailed: false,
    isSearching: false,
    isSaving: false,
    cardTypeInfo: [],
    post: {
      student_id: 0,
      card_id: 0,
      card_name: '',
      add_time: 0,
      add_administrator_id: 0,
      add_administrator: {

      },
      student: {

      },
      store_id: 0,
      store_name: '',
      is_app: 0,
      source_name: '',
      store_source_name: '',
      card_ticket_type_name: '',
      card_ticket_type_id: 0,
      is_new: 0,
      update_time: 0,
      expire_number: '',
      expire_days: '',
      effect_time: '',
      expire_time: '',
      card_payment_mode_id: '',
      card_payment_mode_name: '',
      you_zan_number: '',
      actual_payment: '',
      you_zan_payment: '',
      payment_remark: '',
      receipt: '',
      remark_file: '',
      integral: '',
      is_not_auto_start: 0,
    },
    student: {
      id: 0,
      student_name: '',
      nickname: '',
      selfie: '',
      phone: 0,
      card_number: '',
    },
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
    id() {
      return +this.$route.params.id || 0;
    },
  },
  beforeMount() {
    this.show();
  },
  methods: {
    findPaymentModeName,
    async show() {
      const { isError, data } = await show(this.id);
      if (isError) return;

      const { post } = this;
      const updateData = {};
      Object.keys(post).forEach(key => {
        if (key in data) updateData[key] = data[key];
      });
      Object.assign(post, updateData);
    },
  },
};
</script>
